import * as React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { api } from "../api";
import { Page } from "../DesignSystem/formatting/TwoColumnView";
import { UserJSON, User } from "../models/users";
import { UserCard } from "../User/UserCard";

type EntryFavoritesParams = {
  id: string;
};

export const EntryFavoritesPage = (): JSX.Element => {
  const { id } = useParams<EntryFavoritesParams>();
  const [users, setUsers] = useState<UserJSON[]>([]);

  useEffect(() => {
    const loadFavorites = async () => {
      const results = await api.get<"/api/entry/:id/favorites">(
        `/api/entry/${id}/favorites`
      );

      setUsers(results.users);
    };

    loadFavorites();
  }, [id]);

  return (
    <Page>
      <div className="rounded-2xl border border-slate-200 bg-white/90 px-6 py-5 shadow-sm backdrop-blur-sm dark:border-slate-700 dark:bg-slate-800 dark:shadow-none">
        <h1 className="mb-6 text-2xl font-bold text-slate-800 dark:text-white">
          Favorites
        </h1>
        <div className="space-y-2">
          {users.map((userjson) => {
            const user = new User(userjson);

            return <UserCard key={user.id} user={user} showProfile />;
          })}
        </div>
      </div>
    </Page>
  );
};
